import axios from "services/axios";

export const getCarList = () => async dispatch => {
  dispatch(carListRequest())
  try {
    const { data } = await axios.get("/value-car/all");
    const { data: {carBrand} } = await axios.get("/value-car/brand");
    const { data: {carModel} } = await axios.get("/value-car/model");
    const { data: {carType} } = await axios.get("/value-car/type");
    for(let i=0; i<data.cars.length; i++) {
      data.cars[i].items = data.cars[i].ValueCarTypes
      delete data.cars[i].ValueCarTypes
      for(let j=0; j<data.cars[i].items.length; j++) {
        data.cars[i].items[j].items = data.cars[i].items[j].ValueCarSpecs
        delete data.cars[i].items[j].ValueCarSpecs
      }
    }
    return dispatch(carListRequestSuccess({cars: data.cars, carBrand, carModel, carType}));
  } catch (err) {
    return dispatch(carListRequestFailed(err));
  }
};

export const carListRequest = () => {
  return {
    type: "CAR_LIST_REQUEST",
  };
};

export const carListRequestSuccess = payload => {
  return {
    type: "CAR_LIST_REQUEST_SUCCESS",
    payload,
  };
};

export const carListRequestFailed = err => {
  return {
    type: "CAR_LIST_REQUEST_FAILED",
    payload: err,
  };
};


// WEBPACK FOOTER //
// src/store/actions/car.js